import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    num: '1',
    title: 'Planner de Alimentación Semanal',
    desc: 'Planillas listas para organizar todas tus comidas.'
  }, {
    num: '2',
    title: 'Guía de Compras Sin Gluten',
    desc: 'Aprendé qué productos elegir y cuáles evitar.'
  }, {
    num: '3',
    title: 'Lista de Colaciones Saludables',
    desc: 'Opciones rápidas para cualquier momento del día.'
  }, {
    num: '4',
    title: 'Mini Guía de Cocina Sin Contaminación Cruzada',
    desc: 'Cómo cocinar seguro dentro de casa.'
  }, {
    num: '5',
    title: 'Recetario Express',
    desc: 'Recetas rápidas para días con poco tiempo.'
  }, {
    num: '6',
    title: 'Calendario de Hábitos Saludables',
    desc: 'Seguimiento diario de alimentación y bienestar.'
  }];
  return <section className="py-20 px-4" data-id="element-14">
      <div className="max-w-6xl mx-auto" data-id="element-15">
        <div className="text-center mb-16" data-id="element-16">
          <span className="inline-flex items-center gap-2 text-terracotta font-bold tracking-wider uppercase text-sm mb-4 bg-terracotta/10 px-4 py-1.5 rounded-full" data-id="element-17">
            <Gift className="w-4 h-4" data-id="element-18" /> INCLUIDOS GRATIS
          </span>
          <h2 className="font-serif text-4xl md:text-5xl text-forest" data-id="element-19">
            LOS 6 BONOS EXCLUSIVOS
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-20">
          {bonuses.map((bonus, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1,
          duration: 0.5
        }} className="bg-warm-white p-8 rounded-2xl shadow-warm border border-terracotta/20 hover:border-terracotta/40 transition-colors" data-id="element-21">
              <span className="text-terracotta font-bold text-sm tracking-widest mb-3 block" data-id="element-22">
                BONUS {bonus.num}
              </span>
              <h3 className="font-serif text-xl text-forest mb-3 leading-snug" data-id="element-23">
                {bonus.title}
              </h3>
              <p className="text-muted text-sm leading-relaxed" data-id="element-24">{bonus.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}